// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__22kkj","buttons":"RemoveExpirationActionButtons_buttons__2_qug"};